import { useCallback, useSyncExternalStore } from 'react'

export type Locale = 'en' | 'zh'

const STORAGE_KEY = 'ops-console.locale'
const listeners = new Set<() => void>()

const messages = {
  en: {
    product: 'LLM Gateway',
    workspace: 'Operations workspace',
    operations: 'Operations',
    chat: 'Chat',
    models: 'Models',
    channels: 'Channels',
    apiKeys: 'API Keys',
    integrations: 'Integrations',
    settings: 'Settings',
    live: 'Live service status',
    language: 'Language',
    theme: 'Theme',
    light: 'Light',
    dark: 'Dark',
    system: 'System',
    menu: 'Open navigation',
    closeMenu: 'Close navigation',
  },
  zh: {
    product: 'LLM Gateway',
    workspace: '运维工作区',
    operations: '运营概览',
    chat: '对话',
    models: '模型',
    channels: '渠道',
    apiKeys: 'API 密钥',
    integrations: '集成示例',
    settings: '设置',
    live: '实时服务状态',
    language: '语言',
    theme: '主题',
    light: '浅色',
    dark: '深色',
    system: '跟随系统',
    menu: '打开导航',
    closeMenu: '关闭导航',
  },
} as const

function browserLocale(): Locale {
  if (typeof navigator !== 'undefined' && navigator.language.toLowerCase().startsWith('zh')) return 'zh'
  return 'en'
}

let locale: Locale = (() => {
  if (typeof window === 'undefined') return 'en'
  const saved = window.localStorage.getItem(STORAGE_KEY)
  return saved === 'zh' || saved === 'en' ? saved : browserLocale()
})()

function subscribe(listener: () => void) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

function setLocale(next: Locale) {
  locale = next
  if (typeof window !== 'undefined') window.localStorage.setItem(STORAGE_KEY, next)
  listeners.forEach((listener) => listener())
}

export function useLocale() {
  const current = useSyncExternalStore(subscribe, () => locale, () => 'en' as Locale)
  const change = useCallback((next: Locale) => setLocale(next), [])
  return { locale: current, setLocale: change, t: messages[current] }
}
